<template>
  <div class="container signup-container">
    <h1 class="title">{{ season.name }} Signups Are Open!!</h1>
    <signup-button></signup-button>
  </div>
</template>

<script>
// @ is an alias to /src
import SignupButton from '@/components/SignupButton.vue'
import { mapState } from 'vuex'

export default {
  name: 'SignupContainer',
  components: {
    SignupButton,
  },
  computed: {
    ...mapState(["currentSeason", "upcomingSeason"]),
    season: vm => vm.upcomingSeason || vm.currentSeason
  }
}

</script>